<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        contact us
      </h1>
    </div>
    <div v-if="ready">
      <div class="flex justify-center flex-col mb-16">
        <div class="flex justify-center mb-3 flex-wrap">
          <div class="flex items-center mb-2">
            <nuxt-img
                format="webp"
                src="/icons/question-mark.svg" class="mr-1" width="27" height="27" alt="question-mark"/>
            <span class="uppercase text-darkRed text-2xl">questions?</span>
          </div>
          <div class="flex items-center ml-3 mb-2">
            <nuxt-img
                format="webp" src="/icons/comment.svg" class="mx-3" width="25" height="25" alt="comment"/>
            <span class="uppercase text-darkRed text-2xl">comments?</span>
          </div>
          <div class="flex items-center ml-3 mb-2">
            <nuxt-img
                format="webp" src="/icons/loud-speaker.svg" class="mx-1" width="27" height="27" alt="loud-speaker"/>
            <span class="uppercase text-darkRed text-2xl">need to advertise?</span>
          </div>
        </div>
        <p class="text-center text-tiny">
          Simply fill in the contact form below and one of our team members will contact you.
        </p>
      </div>
      <div class="grid rid-cols-1 md:grid-cols-2 gap-4 mb-3 px-2">
        <div class="left">
          <div class="section-subtitle uppercase mb-6 text-2xl">
            {{title}}
          </div>
          <div class="box-address mb-5">
            <p class="text-tiny">8900 E. Bahia Drive, Suite 101</p>
            <p class="text-tiny">Scottsdale, AZ 85260</p>
            <p class="text-tiny">Phone <a href="tel:480-922-5202">(480) 922-5202</a></p>
            <p class="text-tiny">E-mail <a class="text-darkRed underline" href="mailto:info@nationalhorseman.com">info@nationalhorseman.com</a>
            </p>
          </div>
          <div class="text-3xl ">
            To contact a member of our team directly, please see the <a class="text-darkRed font-semibold	"
                                                                        href="/our-team">Our Team</a> page.
          </div>
        </div>

        <V-Form
            @submit="submit()"
            :validation-schema="schema"
        >
          <div>
            <div class="section-subtitle uppercase mb-6 text-3xl">
              contact form
            </div>
            <div class="mt-1">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
                <front-field>
                  <front-control
                      placeholder="First Name"
                      v-model="form.first_name"
                      name="first_name"
                      type="text"
                  />
                </front-field>

                <front-field>
                  <front-control
                      placeholder="Last Name"
                      v-model="form.last_name"
                      name="last_name"
                      type="text"
                  />
                </front-field>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
                <front-field>
                  <front-control
                      placeholder="Email"
                      type="email"
                      v-model="form.email"
                      name="email"
                  />
                </front-field>

                <front-field>
                  <front-control
                      placeholder="Phone"
                      v-model="form.phone"
                      name="phone"
                      type="tel"
                  />
                </front-field>
              </div>

              <div class="flex justify-center">
                <div class="mb-3 w-full">
                  <front-field>
                    <front-control
                        placeholder="Your message"
                        v-model="form.message"
                        name="message"
                        type="textarea"
                        rows="3"
                    />
                  </front-field>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
                <front-control
                    id="department"
                    type="select"
                    name="department"
                    :options="departments"
                    v-model="department"
                    reduce="id"
                />

                <button type="submit" class="inline-block px-6 py-2.5 bg-themeRed text-white font-medium text-xs leading-tight
              uppercase rounded shadow-md hover:bg-gray-900 hover:shadow-lg focus:bg-gray-900 focus:shadow-lg w-full
              focus:outline-none focus:ring-0 active:bg-gray-900 active:shadow-lg transition duration-150 uppercase text-tiny
              ease-in-out">
                  submit
                </button>
              </div>

            </div>
          </div>
        </V-Form>
      </div>
    </div>
    <div v-else>
      <loaders-spinner />
    </div>
  </div>
</template>
<script setup>
import {http} from "~/utils/http";
import {computed, ref} from "vue";
import {load} from 'recaptcha-v3'
import {ContactForm} from "~/composables/nhTypes";
import * as Yup from "yup";
import Swal from "sweetalert2";
import {useDomainStore} from "@/stores/main";

const domainStore = useDomainStore();
const title = computed(() => domainStore.title);
const siteKey = ref('6Lca3v4lAAAAANhQPd-4oLrghuqYzxDeY9G-5KBG')
const departments = ref([{id: 0, name: 'Select Department'}, {id: 1, name: 'Subscription'}, {
  id: 2,
  name: 'Advertising'
}, {id: 3, name: 'Tehnical Support'}, {id: 4, name: 'Other'}])
const form = ref(new ContactForm());
const department = ref(0);
const schema = Yup.object().shape({
  'first_name': Yup.string().trim().required().nullable().label('First Name'),
  'last_name': Yup.string().trim().required().nullable().label('Last Name'),
  'email': Yup.string().trim().required().nullable().label('Email'),
  'message': Yup.string().trim().required().nullable().label('Message'),
  'department': Yup.number().required().nullable().min(1,'Department is a required field').label('Department'),
});
const ready = ref(true);

const token = ref(null);

async function submit() {
  ready.value = false;
  form.value.department = departments.value[department.value].name;


  if (token.value) {
    try {
      await http.post('/api/contact', {
        form: form.value,
        token: token.value
      }).then((response) => {
        if (response.data.status) {
          Swal.fire({
            icon: 'success',
            title: response.data.message,
          })
          form.value = new ContactForm();
        } else {
          Swal.fire({
            icon: 'warning',
            title: response.data.message,
          })
        }
        ready.value = true;
      })
    } catch (e) {
      ready.value = true;
      console.log(e);
    }
  } else {
    ready.value = true;
    console.log('error reCaptcha')
  }
}

onMounted(async () => {
  const recaptcha = await load(siteKey.value);

  token.value = await recaptcha.execute('login')
})

</script>
